<div class="approval-card-container">
    <app-consent-form [mediaToken]="mediaToken"></app-consent-form>
</div>